import styled from "@emotion/styled";
import { InputElement } from "src/components/Input.styles";
import { PRIMARY_FONT } from "src/constants/colors";

export const EditPageContainer = styled.div`
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
  max-width: 1000px;
  margin: 1rem auto;
`;

export const EditPageHeader = styled.h1`
  text-align: center;
  margin-bottom: 30px;
  font-size: 2rem;
  font-weight: bold;
  border-bottom: 2px solid #ccc;
  padding-bottom: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  gap: 10px;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const InputLabel = styled.label`
  flex: 1;
  font-weight: bold;
  margin-right: 10px;
`;

export const StyledInputElement = styled(InputElement)`
  flex: 2;
  padding: 8px;
  box-sizing: border-box;
`;

export const StyledSelectElement = styled.select`
  z-index: 2;
  background-color: rgba(240, 241, 244, 1);
  border: 0;
  border-radius: 12px;
  color: ${PRIMARY_FONT};
  font-size: 16px;
  font-weight: 400;
  height: 60px;
  margin-bottom: 16px;
  padding: 8px;
  flex: 2;
`;
